import { NotificationStatus } from './../../../models/notification';
import { Action, createAction } from "@ngrx/store";

export const SYSTEM_LOADING = '[System] Loading';

export const UPDATE_STATUS = '[System] Status';

export const CLEAR_SYSTEM = '[System] clear system';

export class UpdateStatus implements Action {
    readonly type = UPDATE_STATUS;
    constructor(public payload: NotificationStatus) { }
}

export class ClearSystemState implements Action {
    readonly type = CLEAR_SYSTEM;
    constructor() { }
}

// To use by other reducers that use the 'createReducer' convenience function.
export const ClearSystemStateAction = createAction(
    CLEAR_SYSTEM
);

export type SystemActions = UpdateStatus | ClearSystemState;